import React, { Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import Root from "../pages/Root";
import Homepage from "../pages/Homepage";
import Actualite from "../pages/Actualite";
import Engagement from "../pages/Engagement";
import Messagerie from "../Components/user/Messagerie";
import Candidate, {
  Cursus,
  Infopersonnel,
  JajouterAuPanier,
  MonPanier,
  PaniersFormation,
} from "../Components/user/Candidate";
import UserCompte from "../Components/user/UserCompte";
import Spiner from "../Components/common/Spiner";
import ErrorPage from "../Components/common/errorPage";

const Contact = React.lazy(() => import("../pages/Contact"));
const About = React.lazy(() => import("../pages/About"));
const Pdg = React.lazy(() => import("../pages/motpdg"));
const Compte = React.lazy(() => import("../pages/Compte"));
const Admission = React.lazy(() => import("../pages/Admission"));
const Campus = React.lazy(() => import("../pages/Campus"));
const ProgPrep = React.lazy(() => import("../pages/PrepaGE"));
const PrepHybride = React.lazy(() => import("../pages/PrepaHybride"));
const AutresProgrammes = React.lazy(() => import("../pages/AutreFormation"));
const AutresServices = React.lazy(() => import("../pages/AutreService"));
// Curriculum
const Curriculum = React.lazy(() => import("../pages/Curriculum"));


const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Homepage />,
      },
      {
        path: "admission",
        element: (
          <Suspense fallback={<Spiner />}>
            <Admission />
          </Suspense>
        ),
      },
      {
        path: "actualite/:id",
        element: <Actualite />,
      },
      {
        path: "engagements",
        element: <Engagement />,
      },
      {
        path: "about",
        element: (
          <Suspense fallback={<Spiner />}>
            <About />
          </Suspense>
        ),
      },
      {
        path: "prepa-gd",
        element: (
          <Suspense fallback={<Spiner />}>
            <ProgPrep />
          </Suspense>
        ),
      },
      {
        path: "prepa-hybride",
        element: (
          <Suspense fallback={<Spiner />}>
            <PrepHybride />
          </Suspense>
        ),
      },
      {
        path: "autre-formation",
        element: (
          <Suspense fallback={<Spiner />}>
            <AutresProgrammes />
          </Suspense>
        ),
      },
      {
        path: "curriculum",
        element: (
          <Suspense fallback={<Spiner />}>
            <Curriculum />
          </Suspense>
        ),
      },
      {
        path: "autre-service",
        element: (
          <Suspense fallback={<Spiner />}>
            <AutresServices />
          </Suspense>
        ),
      },
      {
        path: "pdg",
        element: (
          <Suspense fallback={<Spiner />}>
            <Pdg />
          </Suspense>
        ),
      },
      {
        path: "contacts",
        element: (
          <Suspense fallback={<Spiner />}>
            <Contact />
          </Suspense>
        ),
      },
      {
        path: "/espace-etudiant",
        element: (
          <Suspense fallback={<Spiner />}>
            <Compte />
          </Suspense>
        ),
        children: [
          {
            path: "messagerie",
            element: <Messagerie />,
          },
          {
            path: "candidate",
            element: <Candidate />,
            children: [
              {
                path: "info-personnel",
                element: <Infopersonnel />,
              },
              {
                path: "cursus",
                element: <Cursus />,
              },
              {
                path: "mon-panierformations",
                element: <PaniersFormation />,
                children: [
                  {
                    path: "mon-panier",
                    element: <MonPanier />,
                  },
                  {
                    path: "ajouter-panier",
                    element: <JajouterAuPanier />,
                  },
                ],
              },
            ],
          },
          {
            path: "compte",
            element: <UserCompte />,
          },
        ],
      },
      {
        path: "campus/:name",
        element: (
          <Suspense fallback={<Spiner />}>
            <Campus />
          </Suspense>
        ),
      },
    ],
  },
]);

export default router;
